import React, {
	SetStateAction,
	useState,
	useLayoutEffect,
	useContext
} from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { DynamicShowCaseProps } from 'types/DynamicShowCaseProps';
import { UseTranslationProps } from 'types/UseTranslationProps';
import SimpleInput from 'components/SimpleInput';
import Modal from 'components/Modal';
import Check from 'components/Buttons/Check';
import { color } from 'styles/pallete';
import { saveShowCase, updateShowCase } from './reqs';
import LoadGeneralContext from 'context/LoadGeneralContext';
import SystemNotifyContext from 'context/SystemNotifyContext';
import { getDynamicShowCase } from 'pages/DynamicShowCase/reqs';

interface FormDynamicShowCaseProps {
	isOpen: boolean;
	setIsOpen: React.Dispatch<SetStateAction<boolean>>;
	showCaseToEdit: null | DynamicShowCaseProps;
	setShowCaseToEdit: React.Dispatch<
		SetStateAction<null | DynamicShowCaseProps>
	>;
	setListMenuItensLocation: React.Dispatch<
		React.SetStateAction<DynamicShowCaseProps[]>
	>;
	setActualPage: React.Dispatch<React.SetStateAction<number>>;
	setTotalPages: React.Dispatch<React.SetStateAction<number>>;
	actualPage: number;
}

const initialDataForm: DynamicShowCaseProps = {
	id: '',
	name: '',
	slug: '',
	vtex_query: '',
	show_tab_bar: false,
	header_type: '',
	__typename: 'Page'
};

export default function FormDynamicShowCase({
	isOpen,
	showCaseToEdit,
	setIsOpen,
	setShowCaseToEdit,
	setActualPage,
	setListMenuItensLocation,
	setTotalPages,
	actualPage
}: FormDynamicShowCaseProps) {
	const { t }: UseTranslationProps = useTranslation();

	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);
	const { handleNotify } = useContext(SystemNotifyContext);

	const [dataForm, setDataForm] = useState(initialDataForm);
	const [show_tab_bar, setShow_tab_bar] = useState(false);

	function resetStatesComp() {
		setDataForm(initialDataForm);
		setShowCaseToEdit(null);
	}

	async function handleSave() {
		setIsOpenLoad(true);
		setMessage('Salvando vitrini dinâmica');

		const resp =
			showCaseToEdit === null
				? await saveShowCase(dataForm, handleNotify)
				: await updateShowCase(dataForm, handleNotify);

		if (resp.isSuccess) {
			setMessage('Buscando lista atualizada');
			await getDynamicShowCase(
				setListMenuItensLocation,
				setActualPage,
				setTotalPages,
				actualPage,
				handleNotify
			);
			setIsOpen(false);
			resetStatesComp();
			setIsOpenLoad(false);
		} else {
			setIsOpenLoad(false);
		}
	}

	// o comp check não esta aceitado o dataForm por isso tem um estado dedicado ao show_tab_bar
	useLayoutEffect(() => {
		setDataForm((obj) => ({ ...obj, show_tab_bar: show_tab_bar }));
	}, [show_tab_bar]);

	useLayoutEffect(() => {
		if (showCaseToEdit !== null) {
			setDataForm({
				...showCaseToEdit,
				name: showCaseToEdit.name || '',
				vtex_query: showCaseToEdit.vtex_query || '',
				header_type: showCaseToEdit.header_type || '',
				show_tab_bar: showCaseToEdit.show_tab_bar || false
			});
			setShow_tab_bar(showCaseToEdit.show_tab_bar || false);
		}
	}, []);

	return (
		<Modal
			isOpenProps={isOpen}
			setIsOpenModal={() => {
				setIsOpen((value) => !value);
				resetStatesComp();
			}}
			title={t(
				showCaseToEdit === null
					? 'dynamicShowCase.formDynamicShowCase.newShowcase'
					: 'dynamicShowCase.formDynamicShowCase.editShowcase'
			)}
			buttonClose={false}
		>
			<S.container>
				<SimpleInput
					initialValue={dataForm.name}
					label={t('dynamicShowCase.formDynamicShowCase.pageName')}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, name: value }));
					}}
				/>

				<SimpleInput
					initialValue={dataForm.vtex_query}
					label={t('Query VTEX')}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, vtex_query: value }));
					}}
				/>

				<SimpleInput
					initialValue={dataForm.header_type}
					label={t('dynamicShowCase.formDynamicShowCase.headerType')}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, header_type: value }));
					}}
				/>

				<S.checkBox>
					<Check
						text={t('dynamicShowCase.formDynamicShowCase.isShowTabBar')}
						isChecked={show_tab_bar}
						setIsChecked={setShow_tab_bar}
						colorCheck={color.system.info}
					/>
				</S.checkBox>

				<S.containerBtns>
					<S.cancel
						data-testid="cancelBtn"
						onClick={() => {
							setIsOpen(false);
							resetStatesComp();
						}}
					>
						{t('cancel')}
					</S.cancel>
					<S.save
						data-testid="saveBtn"
						onClick={() => {
							handleSave();
						}}
					>
						{t('save')}
					</S.save>
				</S.containerBtns>
			</S.container>
		</Modal>
	);
}
